import { allFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
import { createFollowerDocumentUid } from "@buildwithflux/models";
export class FirestoreAccountFollowingRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    /**
     * @inheritDoc
     */
    async isFollowed(accountUid, userUid) {
        const followerDocumentUid = createFollowerDocumentUid(accountUid, userUid);
        return this.db
            .accountFollowersData(followerDocumentUid)
            .get()
            .then((snapshot) => {
            return snapshot.exists;
        })
            .catch(() => {
            return false; // TODO: don't silence errors here, throw them
        });
    }
    /**
     * @inheritDoc
     */
    async getByFollowedAccountUid(followedAccountUid) {
        return allFromSnapshot(await this.db.accountFollowersCollection().where("followed_uid", "==", followedAccountUid).get());
    }
    /**
     * @inheritDoc
     */
    async getByFollowerAccountUid(followerAccountUid) {
        return allFromSnapshot(await this.db.accountFollowersCollection().where("follower_uid", "==", followerAccountUid).get());
    }
}
//# sourceMappingURL=FirestoreAccountFollowingRepository.js.map